import { atom } from 'jotai'
import { atomWithStorage } from 'jotai/utils'

export const viewModeAtom = atomWithStorage<'GRID' | 'LIST'>(
    'search-vm',
    'GRID',
)

export const searchTermAtom = atom<string>('')
